// src/components/RecaptchaField/RecaptchaField.jsx
import React from "react";
import PropTypes from "prop-types";
import ReCAPTCHA from "react-google-recaptcha";

const RecaptchaField = ({ onChange, siteKey, innerRef }) => {
  return (
    <div className="my-4 w-full overflow-hidden">
      <ReCAPTCHA
        sitekey={siteKey}
        onChange={onChange}
        ref={innerRef}
      />
    </div>
  );
};

RecaptchaField.propTypes = {
  onChange: PropTypes.func.isRequired,
  siteKey: PropTypes.string.isRequired,
  innerRef: PropTypes.oneOfType([
    PropTypes.func,
    PropTypes.shape({ current: PropTypes.any }),
  ]),
};

export default RecaptchaField;